(() => {
  /**
   * Class representing a details modal.
   */
  class DetailsModal extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');

      // Validate if detailsContainer and summaryToggle exist
      if (!this.detailsContainer || !this.summaryToggle) {
        console.error('Details container or summary toggle not found');
        return;
      }

      this.addEventListeners();
      this.summaryToggle.setAttribute('role', 'button');
    }

    /**
     * Adds event listeners to the modal.
     */
    addEventListeners() {
      this.detailsContainer.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close(event)
      );
      this.summaryToggle.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );
      const closeButton = this.querySelector('button[type="button"]');
      if (closeButton) {
        closeButton.addEventListener(
          'click', (event) => this.close(event)
        );
      }
    }

    /**
     * Checks if the modal is open.
     * 
     * @returns {boolean} True if the modal is open, false otherwise.
     */
    isOpen() {
      return this.detailsContainer.hasAttribute('open');
    }

    /**
     * Handles the click event on the summary toggle.
     * 
     * @param {Event} event - The click event.
     */
    onSummaryClick(event) {
      event.preventDefault();
      const details = event.target.closest('details');
      if (details) {
        details.hasAttribute('open') ? this.close(event) : this.open(event);
      }
    }

    /**
     * Handles the click event on the body.
     * 
     * @param {Event} event - The click event.
     */
    onBodyClick(event) {
      if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(event, false);
    }

    /**
     * Opens the modal.
     * 
     * @param {Event} event - The click event.
     */
    open(event) {
      this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this);
      const details = event.target.closest('details');
      if (details) {
        details.setAttribute('open', true);
      }
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');

      const header = event.target.closest('header');
      if (header) {
        header.classList.add('search-open');
      }

      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }

    /**
     * Closes the modal.
     * 
     * @param {Event} event - The click event.
     * @param {boolean} [focusToggle=true] - Whether to focus the toggle.
     */
    close(event, focusToggle = true) {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
      if (event.target) {
        const header = event.target.closest('header');
        if (header) {
          header.classList.remove('search-open');
        }
      }
    }
  }

  if (!customElements.get('details-modal')) {
    window.DetailsModal = DetailsModal;
    customElements.define('details-modal', DetailsModal);
  }

})();